import name from './name'
import { countUnread } from './slice'

const selectSliceData = state => state[name]

const selectNotifications = state => selectSliceData(state).items || []

/**
 * Prefers the server's count and falls back to counting what is loaded. Once
 * `notificationsGet` paginates, `items` is a page and only the payload count
 * can keep the badge honest (NC-50).
 */
const selectUnreadCount = state => {
  const { unreadCount, items } = selectSliceData(state)
  if (typeof unreadCount === 'number') return unreadCount
  return countUnread(items || [])
}

const selectTotal = state => selectSliceData(state).total || 0

const selectLoading = state => selectSliceData(state).loading || false

const selectLoadingMore = state => selectSliceData(state).loadingMore || false

/** There is another page while the server's `total` outruns what is loaded. */
const selectHasMore = state => {
  const { items, total } = selectSliceData(state)
  return (items || []).length < (total || 0)
}

const selectError = state => selectSliceData(state).error || null

const selectHasLoaded = state => selectSliceData(state).hasLoaded || false

const selectNeedsResync = state => selectSliceData(state).needsResync || false

const selectPreferences = state => selectSliceData(state).preferences

export {
  selectNotifications,
  selectUnreadCount,
  selectTotal,
  selectLoading,
  selectLoadingMore,
  selectHasMore,
  selectError,
  selectHasLoaded,
  selectNeedsResync,
  selectPreferences
}
